module.exports = __webpack_public_path__ + "img/training.dfa534c0.svg";